module.exports = __webpack_public_path__ + "static/netlify-fed92db555182ad0e3c3e943a11bfaba.svg";